import { render } from "./ContactUs.vue?vue&type=template&id=fa29bf14&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "@/assets/styles/contactus.scss?vue&type=style&index=0&id=fa29bf14&scoped=true&lang=scss"

import exportComponent from "/home/djokic/Projects/mariv/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa29bf14"]])

export default __exports__